module.exports = __webpack_public_path__ + "static/media/twitter.25a46f73.svg";